export default "__VITE_ASSET__BfGxscv2__"